import { Pipe, PipeTransform } from '@angular/core';
import { FlattenSeat } from '../types';
import { TextFormattingUtils } from '../utils';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {

  public transform(rule: string, seat: FlattenSeat): string {
    return TextFormattingUtils.formatText(rule, seat);
  }
}
